export default "__VITE_ASSET__B96LUp4e__"